"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Money_1 = __importDefault(require("components/Money"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var TeamPreviewHeader = function (_a) {
    var team = _a.team, spend = _a.spend, toolsCount = _a.toolsCount;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mb: 8, width: 676, pt: 9.5 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1, noWrap: true, fontWeight: 600, fontSize: 32, lineHeight: "1.25" }, { children: (team === null || team === void 0 ? void 0 : team.name) || 'Team' })), team && ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ mt: 4 }, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: spend || 0 }), " (1Y) \u00B7 ", toolsCount, toolsCount === 1 ? ' tool' : ' tools', " \u00B7 ", team.headcount, " headcount"] })))] })));
};
exports.default = TeamPreviewHeader;
